import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONTS } from '../pdfTypography';

const styles = StyleSheet.create({
  container: {
    marginTop: 18,
    marginBottom: 6,
    minPresenceAhead: 80,
  },
  title: {
    fontSize: PDF_FONTS.sectionTitle,
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: 2,
  },
  subtitle: {
    fontSize: PDF_FONTS.body,
    color: '#000000',
  },
});

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle }) => (
  <View style={styles.container} wrap={false}>
    <Text style={styles.title}>{title}</Text>
    {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
  </View>
);

export default SectionHeader;
